import NovozymesLanding from './NovozymesModule';

export default NovozymesLanding;
